import {connect} from '../../app/connect';
import LinkToDocument from './LinkToDocument';
import {fetchProjectFolders, fetchFolderContents, openPushpinSelection, closePushpinSelection} from '../../app/actions';
import {getCurrentPreviewIssueAttributes, getCurrentViewType} from '../../app/selectors';
import {getUrn} from '../../utils/issues-helpers';

export default connect(
  state => ({
    viewType: getCurrentViewType(state),
    currentLinkedUrn: getUrn(getCurrentPreviewIssueAttributes(state))
  }),
  {
    fetchProjectFolders,
    fetchFolderContents,
    openPushpinSelection,
    closePushpinSelection
  }
)(LinkToDocument);
